import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
//import Hidden from '@mui/material/Hidden';
import useStyles from './Styles';

interface Props {
    name: string,
    value: any,
	noWrap?: boolean,
    widths?: string[],
}

const RowTable:React.FC<Props> = (props)=> {
    const classes = useStyles();
	let whiteSpace = 'normal' as 'normal'|'nowrap';
	if( props.noWrap!==null && props.noWrap===true ){
		whiteSpace = 'nowrap';
	}
	return (
        <TableRow>
            <TableCell
                sx={{
                    padding: '0.5em',
                    paddingRight: { sm: '2em', xs: '0em' },
                    whiteSpace: whiteSpace,
                    display: { xs: 'none', sm: 'table-cell' },
                    width: (props.widths && props.widths[0] && props.widths[0]!=='') ? props.widths[0] : 'none',
                }}
                className={classes.rowLabel}
            >
                {props.name}
            </TableCell>
            <TableCell sx={{
                padding:"0.5em 0",
                width: (props.widths && props.widths[1] && props.widths[1]!=='') ? props.widths[1] : 'none',
            }}>
                <Box
                    className={classes.rowLabel}
                    sx={{
                        marginBottom:'0.5em',
                        display: { xs: 'block', sm: 'none' }
                    }}
                >
                    {props.name}
                </Box>
                <span className={classes.rowValue}>{props.value}</span>
            </TableCell>
        </TableRow>
    );
}

export default RowTable;
